/* unplugin-vue-components disabled */import script from "./Sendingrecord.vue?vue&type=script&setup=true&name=Sendingrecord&lang=js"
export * from "./Sendingrecord.vue?vue&type=script&setup=true&name=Sendingrecord&lang=js"

const __exports__ = script;

export default __exports__